import {
  getBackendClient,
  unwrapApiResponse,
  type ApiSchema,
  type BackendClientOptions,
} from './client'

export type EffectiveUserContext = ApiSchema<'GetEffectiveUserContext'>
export type ImpersonationSession = ApiSchema<'GetImpersonationSession'>

export async function getMeContext(
  options: BackendClientOptions = {},
): Promise<EffectiveUserContext> {
  const client = getBackendClient(options)
  return unwrapApiResponse(client.GET('/me/context'))
}

export async function createImpersonationSession(
  customerId: string,
  options: BackendClientOptions = {},
): Promise<ImpersonationSession> {
  const client = getBackendClient(options)
  return unwrapApiResponse(
    client.POST('/impersonation-sessions', {
      body: { customer_id: customerId },
    }),
  )
}

export async function deleteImpersonationSession(
  sessionId: string,
  options: BackendClientOptions = {},
): Promise<void> {
  const client = getBackendClient(options)
  await unwrapApiResponse(
    client.DELETE('/impersonation-sessions/{session_id}', {
      params: { path: { session_id: sessionId } },
    }),
  )
}
